module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("bxLht"))).then(() => parcelRequire('hEqeo'));